const mutations = {
  // # Axios ###################
  // #################### Axios #
  SET_LOGIN_CODE: (state, code) => {
    state.loginStatusCode = code;
  },
  SET_REGISTRATION_IN_PROGRESS: (state, inProgress) => {
    state.registrationInProgress = inProgress;
  },
  SET_LOGOUT_IN_PROGRESS: (state, inProgress) => {
    state.logoutInProgress = inProgress;
  },
  // Payment ##############
  SET_BOOSTS: (state, boosts) => {
    state.boosts = boosts;
  },
  SET_ORDERS: (state, orders) => {
    state.orders = orders;
  },
  SET_SUBSCRIPTIONS: (state, subscriptions) => {
    state.subscriptions = subscriptions;
  },
  SET_PROMOTIONS: (state, promotions) => {
    state.promotions = promotions;
  },
  SET_PAYMENT_INFORMATION: (state, paymentInformation) => {
    state.paymentInformation = paymentInformation;
  },
  SET_PACKAGES: (state, packages) => {
    state.packages = packages;
  },
  SET_STRIPE_SUBSCRIPTIONS: (state, stripeSubscriptions) => {
    state.stripeSubscriptions = stripeSubscriptions;
  },
  SET_STRIPE_SUBSCRIPTION_ITEMS: (state, stripeSubscriptionItems) => {
    state.stripeSubscriptionItems = stripeSubscriptionItems;
  },

  SET_STRIPE_CUSTOMER: (state, stripeCustomer) => {
    state.stripeCustomer = stripeCustomer;
  },
  SET_STRIPE_SUBSCRIPTIONS_HISTORY: (state, stripeSubscriptionsHistory) => {
    state.stripeSubscriptionsHistory = stripeSubscriptionsHistory;
  },
  SET_STRIPE_INVOICES_HISTORY: (state, stripeInvoicesHistory) => {
    state.stripeInvoicesHistory = stripeInvoicesHistory;
  },
  SET_STRIPE_PLANS: (state, stripePlans) => {
    state.stripePlans = stripePlans;
  },
  SET_FREEMIUM: (state, freemium) => {
    state.freemium = freemium;
  },


  // ################### Payment
};

export default mutations;
